export const CURRENT_PRIVACY_VERSION = "2026-03-01";
export const CURRENT_SHOP_TOS_VERSION = "2026-03-01";
export const CURRENT_PASSPORT_TOS_VERSION = "2026-03-01";
export const CURRENT_BETA_AGREEMENT_VERSION = "2026-03-01";
export const CURRENT_AGE_VERIFICATION_VERSION = "2026-03-01";
